export enum NODE_TYPES {
  DATASET = 'DATASET',
  COLLECTION = 'COLLECTION',
  FEATURE = 'FEATURE'
}

export interface FeatureNode {
  name: string;
  id: string;
  type: NODE_TYPES,
  nodeData: any,
  children?: FeatureNode[];
  expandable?: boolean;
  level?: number;
}
